$(function () {
    var body = $('body');
    var nav = $('.nav');
    var burger = $('.burger');
    var search = $('.header .search-menu-icon');
    var search_menu = $('.search-menu');
    var nav_trigger = $('.nav').find('ul li');
    var nav_align = 'right';
    var break_point = 1200;
    var browser_width = window.innerWidth;
    var nav_width = 300;
    var nav_wrap = $('.navwrap');

    // search click
    if (browser_width <= break_point) {
        search.click(function () {

            // check if burger menu is open -> if it is, close it.
            if (nav_wrap.hasClass('__active')) {
                burger.removeClass('__active');
                nav_wrap.removeClass('__active');
                body.removeClass('__mobile');
                nav_wrap.find('.menu-item-has-children').find('ul').slideUp();
            }

            if (body.hasClass('__search')) {
                search.removeClass('__active');
                search_menu.removeClass('__active');
                body.removeClass('__search');
            } else {
                search.addClass('__active');
                search_menu.addClass('__active');
                body.addClass('__search');
            }
        })
    }

    //burger click
    burger.click(function (event) {
        event.preventDefault();

        // check is search is open -> close it if it does
        if (search.hasClass('__active')) {
            search.removeClass('__active');
            search_menu.removeClass('__active');
            body.removeClass('__search')
        }

        // check if body has __mobile class
        if (body.hasClass('__mobile')) {
            nav_reset();
            $(this).removeClass('__active');
        } else {
            nav_launch();
            $(this).addClass('__active');
        }
    });

    /*nav reset*/
    var nav_reset = function nav_reset() {
        burger.removeClass('__active');
        body.removeClass('__mobile');
        nav_wrap.removeClass('__active');
        nav_wrap.find('ul').removeClass('__active');
        nav_wrap.find('.menu-item-has-children').find('ul').slideUp();
    };

    /*nav launch*/
    var nav_launch = function nav_launch() {
        body.addClass('__mobile');
        nav_wrap.addClass('__active');
    };

    // nav dropdown on focus/keyboard navigation
    if (browser_width >= break_point) {
        $('.menu-item').focusin(function () {
            $(this).addClass('__active');
            $(this).children('button').attr('aria-expanded', true);
        });
        $('.menu-item').focusout(function () {
            $(this).removeClass('__active');
            $(this).children('button').attr('aria-expanded', false);
        });
        $('.menu-item').mouseover(function () {
            $(this).children('button').attr('aria-expanded', true);
        });
        $('.menu-item').mouseout(function () {
            $(this).children('button').attr('aria-expanded', false);
        });
    }

    if (browser_width < break_point) {
        nav_trigger.click(function (event) {
            var submenu_trigger = $(this).find('.menu-item-has-children > ul');
            event.stopPropagation();
            $(this).toggleClass('__active');
            if ($(this).children('ul').length > 0) {
                event.preventDefault();
                if (!$(this).hasClass('__megamenu')) {
                    $(this)
                        .closest('.menu-item-has-children')
                        .find('>ul')
                        .slideToggle(300);
                } else {
                    $(this)
                        .find('>ul')
                        .slideToggle(300);
                }
            }
        });
    }


    // Touch device check
    const isTouchDevice = () => {
        return window.matchMedia("(pointer: coarse)").matches
    }
    // If desktop and touch device, disable link click and add extra view link
    if (browser_width > break_point && isTouchDevice()) {
        nav_trigger.click(function (event) {
            event.stopPropagation();
            if ($(this).children('ul').length > 0) {
                event.preventDefault();
            }
        });
    }

    if (browser_width <= break_point) {
        var headerHeight = $('.header').outerHeight(true);
        nav_wrap.css('top', `${headerHeight}px`);
        search_menu.css('top', `${headerHeight}px`);
    }

    if (browser_width >= break_point) {
        /** Sets card text/links based on an element's data-attributes */
        const setCardInfo = function (element, card) {
            // get all data attributes from element
            var image = element.data('image');
            var resort = element.data('resort');
            var country = element.data('country');
            var name = element.data('name');
            var beds = element.data('beds');
            var price = element.data('price');
            var link = element.data('link');
            var tag = element.data('tag');
            var wishlist = element.data('wishlist');

            // get all card elements
            var cardImage = card.find('img');
            var cardResort = card.find('.megamenu-card-location span').first();
            var cardCountry = card.find('.megamenu-card-location span').last();
            var cardName = card.find('.megamenu-card-title');
            var cardBeds = card.find('.megamenu-card-beds');
            var cardPrice = card.find('.megamenu-card-price');
            var cardTag = card.find('.megamenu-card-tag');

            card.removeClass("__saved");

            // set card elements to element's data attributes
            card.attr('href', link);
            cardImage.attr('src', image);
            cardResort.html(resort);
            cardCountry.html(country);
            cardName.html(name);
            cardBeds.html(`Sleeps ${beds}`);
            cardPrice.html(price);
            cardTag.html(tag);

            if (wishlist) {
                card.addClass("__saved");
            }
        };

        const resetAllSubMenus = function () {
            var megaMenu = $('.__megamenu');
            var megaMenuSubLink = megaMenu.find('.menu-item-has-children');
            var megaMenuSubMenus = megaMenuSubLink.find('ul');

            megaMenuSubMenus.removeClass('__active');
        }

        const setFirstMenu = function () {
            var firstMenu = megaMenu.find('ul[data-menu]').first();
            var firstMenuLink = firstMenu.find('a').first();
            var firstMenuCard = firstMenu.closest('.menu-item').find('.megamenu-card').first();
            firstMenu.addClass('__active');
            firstMenuCard.addClass('__active');
            setCardInfo(firstMenuLink, firstMenuCard);
        }

        var megaMenu = $('.__megamenu');
        megaMenu.hover(function () {
            var firstLink = $(this).find('ul[data-menu=1] a').first();
            var firstCard = $(this).find('.megamenu-card').first();

            setFirstMenu();
            setCardInfo(firstLink, firstCard);
            $(this).addClass('__active');
        }, function () {
            $(this).removeClass('__active');
        });

        /* MEGAMENU */
        var megaMenu = $('.__megamenu');
        var container = megaMenu.find('.container');
        var megaMenuContainerLink = megaMenu.find('.menu-item-has-children > a');
        var megaMenuContainerUL = megaMenu.find('.menu-item-has-children > ul');
        var megaMenuCard = $('.megamenu-card');

        var menuItemWithChildren = megaMenu.find('.menu-item-has-children');

        menuItemWithChildren.each(function () {
            $(this).hover(function () {
                resetAllSubMenus();
            })
        });

        // set background gradient width based on container width
        var widthCalculation = (container.width() / 4) + 45;
        megaMenuContainerLink.css({
            'width': `${container.width() / 4}px`,
        });

        container.css({
            'background': `linear-gradient(to right, #0B2A56 ${widthCalculation}px, #0C326A ${widthCalculation}px)`
        });

        if (browser_width >= 1200) {
            megaMenuContainerUL.css({
                'left': `${container.width() / 4}px`,
                'width': `${container.width() / 1.75}px`
            });

            megaMenuCard.css({
                'left': `${container.width() / 1.4}px`,
                'width': `${container.width() / 4}px`
            });
        } else {
            megaMenuContainerUL.css({
                'left': `${container.width() / 4}px`,
                'width': `${container.width() / 2}px`
            });

            megaMenuCard.css({
                'left': `${container.width() / 1.4}px`,
                'width': `${container.width() / 3.25}px`
            });
        }

        // open submenus on hover/focus
        var megamenuSubTrigger = $('.__megamenu .menu-item');
        megamenuSubTrigger.each(function () {
            var thisElement = $(this);
            var dataMenu = thisElement.data('menu');
            var relatedMenu = thisElement.find(`ul[data-menu=${dataMenu}]`);
            var subMenuItem = thisElement.find('.submenu a:not(.megamenu-viewall)');
            var relatedCard = thisElement.find('.megamenu-card');
            var firstLink = thisElement.find('ul[data-menu] a').first()

            thisElement.hover(function () {
                setCardInfo(firstLink, relatedCard);
            });

            thisElement.focusin(function () {
                relatedMenu.addClass('__active');
                relatedCard.show();
            });

            relatedCard.focusout(function () {
                relatedMenu.removeClass('__active');
                relatedCard.hide();
            });

            subMenuItem.each(function () {
                var thisElement = $(this);
                var chaletCard = thisElement.closest('.menu-item').find('.megamenu-card');

                thisElement.hover(function () {
                    setCardInfo(thisElement, chaletCard);
                });

                thisElement.focusin(function () {
                    setCardInfo(thisElement, chaletCard);
                });
            })
        });

        setFirstMenu();
    }

    // MENU SHRINK ON SCROLL
    if (browser_width >= break_point) {
        $(window).scroll(function () {
            let scroll = $(window).scrollTop();
            if (scroll >= 200) {
                $('header').addClass('__scrolled');
            } else {
                $('header').removeClass('__scrolled');
            }
        });
    }
});